import React from 'react'

import { Helmet } from 'react-helmet'

import './donate.css'

const Donate = (props) => {
  return (
    <div className="donate-container">
      <Helmet>
        <title>
          Donate - FutureHeirs | Faith-Based Non-Profit Empowering Future
          Leaders
        </title>
        <meta
          name="description"
          content="Faith-based non-profit bridging quality education and accessibility. Empowering children through Christ-centered learning, tech literacy &amp; character development"
        />
        <meta
          property="og:title"
          content="Donate - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders"
        />
        <meta
          property="og:description"
          content="Bridging quality education and accessibility through Christ-centered learning. Empowering every child to flourish in their unique calling with faith and innovation."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/97765a8c-e132-4703-821d-7a550778f912/2688ccf9-cb16-49f3-aba4-ad25e1010654?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <div className="donate-donate">
        <div className="donate-frame12">
          <div className="donate-frame14">
            <div className="donate-frame162">
              <img
                alt="VectorI364"
                src="/external/vectori364-99w.svg"
                className="donate-vector1"
              />
              <span className="donate-text100">futureheirs</span>
            </div>
            <div className="donate-frame81">
              <div className="donate-frame6">
                <span className="donate-text101">Home</span>
              </div>
              <div className="donate-frame7">
                <span className="donate-text102">About Us</span>
              </div>
              <div className="donate-frame82">
                <span className="donate-text103">Contact Us</span>
              </div>
              <div className="donate-frame9">
                <span className="donate-text104">Blog</span>
              </div>
            </div>
            <div className="donate-component410">
              <span className="donate-text105">Join Us</span>
            </div>
          </div>
          <div className="donate-frame13">
            <div className="donate-frame195">
              <img
                alt="Line653643"
                src="/external/line653643-y7tn.svg"
                className="donate-line65"
              />
              <span className="donate-text106">Donate</span>
            </div>
            <span className="donate-text107">
              Your generosity fuels education, leadership, and transformation.
              Every gift makes a difference!
            </span>
          </div>
        </div>
        <img
          alt="Rectangle43643"
          src="/external/rectangle43643-4fp.svg"
          className="donate-rectangle4"
        />
        <div className="donate-frame3060">
          <div className="donate-frame3059">
            <div className="donate-frame3053">
              <span className="donate-text108">
                How Your Gift Makes an Impact
              </span>
              <div className="donate-frame3052">
                <div className="donate-frame3050">
                  <div className="donate-frame3047">
                    <div className="donate-frame163">
                      <div className="donate-frame30491">
                        <span className="donate-text109">$25</span>
                        <span className="donate-text110">
                          Provides a student with essential tech learning
                          materials for one month.
                        </span>
                      </div>
                      <div className="donate-component411">
                        <span className="donate-text111">Donate $25</span>
                      </div>
                    </div>
                    <div className="donate-frame30451">
                      <div className="donate-frame30492">
                        <span className="donate-text112">$50</span>
                        <span className="donate-text113">
                          Supports digital literacy training for one student.
                        </span>
                      </div>
                      <div className="donate-component412">
                        <span className="donate-text114">Donate $50</span>
                      </div>
                    </div>
                    <div className="donate-frame30461">
                      <div className="donate-frame30493">
                        <span className="donate-text115">$100</span>
                        <span className="donate-text116">
                          Enables a student to attend our Leadership Development
                          workshop.
                        </span>
                      </div>
                      <div className="donate-component413">
                        <span className="donate-text117">Donate $100</span>
                      </div>
                    </div>
                  </div>
                  <div className="donate-frame3048">
                    <div className="donate-frame164">
                      <div className="donate-frame30494">
                        <span className="donate-text118">$250</span>
                        <span className="donate-text119">
                          Sponsors one student&apos;s full semester at our
                          Online Learning Academy.
                        </span>
                      </div>
                      <div className="donate-component414">
                        <span className="donate-text120">Donate $250</span>
                      </div>
                    </div>
                    <div className="donate-frame30452">
                      <div className="donate-frame30495">
                        <span className="donate-text121">$500</span>
                        <span className="donate-text122">
                          Funds tech equipment for one of our Community Learning
                          Hubs.
                        </span>
                      </div>
                      <div className="donate-component415">
                        <span className="donate-text123">Donate $500</span>
                      </div>
                    </div>
                    <div className="donate-frame30462">
                      <div className="donate-frame30496">
                        <span className="donate-text124">$1000</span>
                        <span className="donate-text125">
                          Establishes a scholarship for a deserving student for
                          a full year.
                        </span>
                      </div>
                      <div className="donate-component416">
                        <span className="donate-text126">Donate $1000</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="donate-frame3051">
                  <span className="donate-text127">Support Our Mission</span>
                  <div className="donate-cta">
                    <div className="donate-frame3">
                      <span className="donate-text128">
                        Enter a custom amount
                      </span>
                    </div>
                    <div className="donate-component417">
                      <span className="donate-text129">Donate</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="donate-frame3010">
              <span className="donate-text130">Ways to Give</span>
              <div className="donate-frame3034">
                <div className="donate-frame3009">
                  <div className="donate-waystogive1">
                    <span className="donate-text131">One-Time Gift</span>
                    <span className="donate-text132">
                      Make an immediate impact with a single donation of any
                      amount.
                    </span>
                  </div>
                  <div className="donate-waystogive2">
                    <span className="donate-text133">Corporate Matching</span>
                    <span className="donate-text134">
                      Many companies offer matching gift programs. Check if your
                      employer will match your donation and double your impact!
                    </span>
                  </div>
                </div>
                <img
                  alt="volunteerholdingboxcontainingdonationscharity3663"
                  src="/external/volunteerholdingboxcontainingdonationscharity3663-gugk-500w.png"
                  className="donate-volunteerholdingboxcontainingdonationscharity"
                />
                <div className="donate-frame3008">
                  <div className="donate-waystogive3">
                    <span className="donate-text135">Monthly Giving</span>
                    <span className="donate-text136">
                      Join our Circle of Supporters by setting up a recurring
                      monthly donation. Your sustained support helps us plan
                      effectively and reach more children.
                    </span>
                  </div>
                  <div className="donate-waystogive4">
                    <span className="donate-text137">Legacy Giving</span>
                    <span className="donate-text138">
                      Include FutureHeirs in your estate planning and leave a
                      lasting legacy that will impact generations to come.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="donate-frame145">
              <span className="donate-text139">Donation Options</span>
              <div className="donate-frame143">
                <div className="donate-frame165">
                  <div className="donate-frame191">
                    <div className="donate-group391">
                      <img
                        alt="Ellipse13664"
                        src="/external/ellipse13664-vqahm-200h.png"
                        className="donate-ellipse11"
                      />
                      <img
                        alt="websvgrepocom13724"
                        src="/external/websvgrepocom13724-9awv.svg"
                        className="donate-websvgrepocom1"
                      />
                    </div>
                    <span className="donate-text140">Online</span>
                  </div>
                  <span className="donate-text141">
                    Make a secure donation through our online payment system.
                  </span>
                  <div className="donate-component418">
                    <span className="donate-text142">Donate Online</span>
                  </div>
                </div>
                <div className="donate-frame192">
                  <div className="donate-frame193">
                    <div className="donate-group392">
                      <img
                        alt="Ellipse13664"
                        src="/external/ellipse13664-1qil-200h.png"
                        className="donate-ellipse15"
                      />
                      <div className="donate-vuesaxboldsms1">
                        <div className="donate-vuesaxboldsms2">
                          <div className="donate-sms1">
                            <img
                              alt="Vector3664"
                              src="/external/vector3664-98c.svg"
                              className="donate-vector2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="donate-text143">By Mail</span>
                  </div>
                  <span className="donate-text144">
                    <span className="donate-text145">
                      Send your check to: FutureHeirs 123 Faith &amp; Innovation
                      Way Your City, State 12345
                    </span>
                    <br></br>
                    <br></br>
                    <span className="donate-text148">
                      Please make checks payable to
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span>&quot;FutureHeirs&quot;</span>
                  </span>
                </div>
                <div className="donate-frame18">
                  <div className="donate-frame194">
                    <div className="donate-group40">
                      <img
                        alt="Ellipse13664"
                        src="/external/ellipse13664-y7nn-200h.png"
                        className="donate-ellipse16"
                      />
                      <img
                        alt="phonesvgrepocom13724"
                        src="/external/phonesvgrepocom13724-jxfh.svg"
                        className="donate-phonesvgrepocom1"
                      />
                    </div>
                    <span className="donate-text150">Bank Transfer</span>
                  </div>
                  <span className="donate-text151">
                    For wire transfer information, please contact us at
                    giving@futureheirs.org
                  </span>
                  <div className="donate-component419">
                    <span className="donate-text152">Contact Us</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="donate-frame239">
              <div className="donate-frame236">
                <div className="donate-frame2181">
                  <span className="donate-text153">
                    Transparency &amp; Accountability
                  </span>
                  <span className="donate-text154">
                    FutureHeirs is committed to financial transparency and
                    responsible stewardship. We&apos;re proud that 85% of all
                    donations go directly to our educational programs. Our
                    annual financial reports are available upon request.
                  </span>
                </div>
                <div className="donate-group125">
                  <span className="donate-text155">
                    501(c)(3) non-profit organization
                  </span>
                  <span className="donate-text156">
                    Registered charity #12-3456789
                  </span>
                  <span className="donate-text157">
                    Annual financial audits by independent accounting firm
                  </span>
                  <span className="donate-text158">
                    Board oversight of all financial decisions
                  </span>
                  <img
                    alt="Ellipse93664"
                    src="/external/ellipse93664-nr4-200h.png"
                    className="donate-ellipse9"
                  />
                  <img
                    alt="Ellipse123664"
                    src="/external/ellipse123664-9cik-200h.png"
                    className="donate-ellipse12"
                  />
                  <img
                    alt="Ellipse133664"
                    src="/external/ellipse133664-sfwh-200h.png"
                    className="donate-ellipse13"
                  />
                  <img
                    alt="Ellipse143694"
                    src="/external/ellipse143694-9b7d-200h.png"
                    className="donate-ellipse14"
                  />
                  <img
                    alt="Line673664"
                    src="/external/line673664-y4jc.svg"
                    className="donate-line67"
                  />
                  <img
                    alt="Line683664"
                    src="/external/line683664-5yc9.svg"
                    className="donate-line68"
                  />
                  <img
                    alt="Line693694"
                    src="/external/line693694-hh3b.svg"
                    className="donate-line69"
                  />
                </div>
              </div>
              <img
                alt="volunteergivingboxwithdonationsanothervolunteer3664"
                src="/external/volunteergivingboxwithdonationsanothervolunteer3664-4afn-500w.png"
                className="donate-volunteergivingboxwithdonationsanothervolunteer"
              />
            </div>
            <div className="donate-frame3054">
              <img
                alt="volunteercollectingdonationboxfromanothervolunteer3694"
                src="/external/volunteercollectingdonationboxfromanothervolunteer3694-r8xa-200h.png"
                className="donate-volunteercollectingdonationboxfromanothervolunteer"
              />
              <div className="donate-frame2182">
                <span className="donate-text159">Other Ways to Support</span>
                <div className="donate-frame3057">
                  <div className="donate-frame3056">
                    <div className="donate-waystogive5">
                      <span className="donate-text160">Sponsor a Program</span>
                      <span className="donate-text161">
                        Fund a specific initiative that aligns with your giving
                        goals.
                      </span>
                    </div>
                    <div className="donate-waystogive6">
                      <span className="donate-text162">Donate Equipment</span>
                      <span className="donate-text163">
                        Contribute new or gently used tech equipment to our
                        learning centers.
                      </span>
                    </div>
                  </div>
                  <div className="donate-frame3055">
                    <div className="donate-waystogive7">
                      <span className="donate-text164">Fundraise for Us</span>
                      <span className="donate-text165">
                        Create your own fundraising campaign through your
                        school, church, or community.
                      </span>
                    </div>
                    <div className="donate-waystogive8">
                      <span className="donate-text166">Gifts in Kind</span>
                      <span className="donate-text167">
                        Provide professional services, software licenses, or
                        other resources.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="donate-frame3058">
              <div className="donate-frame3037">
                <div className="donate-frame207">
                  <span className="donate-text168">Questions?</span>
                  <span className="donate-text169">
                    <span className="donate-text170">
                      Our Donor Relations team is here to help!
                    </span>
                    <br></br>
                    <span className="donate-text172">Contact us at;</span>
                    <br></br>
                    <span className="donate-text174">
                      giving@futureheirs.org
                    </span>
                    <br></br>
                    <span className="donate-text176">or call</span>
                    <br></br>
                    <span>(555) 123-4567 ext. 2.</span>
                  </span>
                </div>
              </div>
              <div className="donate-frame3036">
                <span className="donate-text179">Thank You</span>
                <span className="donate-text180">
                  <span className="donate-text181">
                    Your generosity makes our mission possible. Thank you for
                    believing in the potential of every child and for partnering
                    with us to prepare the next generation of leaders.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    FutureHeirs is a registered 501(c)(3) non-profit
                    organization. All donations are tax-deductible to the full
                    extent allowed by law.
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="donate-frame189">
            <div className="donate-frame184">
              <div className="donate-group107">
                <span className="donate-text185">Company</span>
                <div className="donate-frame2491">
                  <span className="donate-text186">Home</span>
                  <span className="donate-text187">About Us</span>
                  <span className="donate-text188">Contact Us</span>
                  <span className="donate-text189">Programs</span>
                  <span className="donate-text190">Approach</span>
                </div>
              </div>
              <div className="donate-group106">
                <span className="donate-text191">Quick Links</span>
                <div className="donate-frame2492">
                  <span className="donate-text192">Partner with Us</span>
                  <span className="donate-text193">Volunteer</span>
                  <span className="donate-text194">Donate</span>
                  <span className="donate-text195">Blog</span>
                </div>
              </div>
              <div className="donate-group105">
                <span className="donate-text196">Terms and Policies</span>
                <div className="donate-frame248">
                  <span className="donate-text197">Privacy Policy</span>
                  <span className="donate-text198">Terms and Conditions</span>
                  <span className="donate-text199">Feedback</span>
                  <span className="donate-text200">FAQs</span>
                </div>
              </div>
              <div className="donate-group104">
                <span className="donate-text201">Contact Information</span>
                <div className="donate-group87">
                  <span className="donate-text202">
                    connect@futureheirs.org
                  </span>
                  <div className="donate-vuesaxboldsms3">
                    <div className="donate-vuesaxboldsms4">
                      <div className="donate-sms2">
                        <img
                          alt="VectorI364"
                          src="/external/vectori364-ufc.svg"
                          className="donate-vector3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="donate-group88">
                  <span className="donate-text203">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="donate-vuesaxboldlocation1">
                    <div className="donate-vuesaxboldlocation2">
                      <img
                        alt="VectorI364"
                        src="/external/vectori364-s4l8.svg"
                        className="donate-vector4"
                      />
                    </div>
                  </div>
                </div>
                <div className="donate-group89">
                  <span className="donate-text204">(555) 123-4567</span>
                  <div className="donate-vuesaxboldcall1">
                    <div className="donate-vuesaxboldcall2">
                      <div className="donate-call">
                        <img
                          alt="VectorI364"
                          src="/external/vectori364-jd8o.svg"
                          className="donate-vector5"
                        />
                        <img
                          alt="VectorI364"
                          src="/external/vectori364-gp6d.svg"
                          className="donate-vector6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I364"
              src="/external/line2i364-469m.svg"
              className="donate-line2"
            />
            <div className="donate-frame183">
              <div className="donate-frame161">
                <img
                  alt="VectorI364"
                  src="/external/vectori364-l89.svg"
                  className="donate-vector7"
                />
                <span className="donate-text205">futureheirs</span>
              </div>
              <div className="donate-frame180">
                <span className="donate-text206">Follow Us:</span>
                <div className="donate-frame177">
                  <div className="donate-vuesaxboldfacebook1">
                    <div className="donate-vuesaxboldfacebook2">
                      <div className="donate-facebook">
                        <img
                          alt="VectorI364"
                          src="/external/vectori364-ez.svg"
                          className="donate-vector8"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI364"
                    src="/external/riinstagramfilli364-qmbr.svg"
                    className="donate-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI364"
                    src="/external/pajamaslinkedini364-ei8q.svg"
                    className="donate-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI364"
                    src="/external/fa6brandssquarextwitteri364-n35.svg"
                    className="donate-fa6brandssquarextwitter"
                  />
                  <div className="donate-vuesaxboldyoutube1">
                    <div className="donate-vuesaxboldyoutube2">
                      <div className="donate-youtube">
                        <img
                          alt="VectorI364"
                          src="/external/vectori364-7qrf.svg"
                          className="donate-vector9"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Donate
